import Konva from 'konva';
import { SizeType } from 'types/Canvas';
import { getScale } from 'utils/konva';
import { ScalingType } from 'types/Scene';

const HOVER_RECT_BORDER = 2;
export const HOVER_RECT_ID = 'layerHoverRect';
const HOVER_RECT_FILL = '#C209C114';
const HOVER_RECT_FILL_VISIBLE = '#C209C1';

export type BackgroundChooser = {
  update: () => void;
  setHoverRectVisible: (visibility: boolean) => void;
  setBackgroundVisible: (visibility: boolean) => void;
  hoverRect: Konva.Rect;
};
export const createBackgroundChooser = (
  konvaLayer: Konva.Layer,
  currentSceneId: string,
  size: SizeType,
  width: number,
  height: number,
  scalingMode: ScalingType
): BackgroundChooser => {
  const hoverRect = new Konva.Rect({
    id: HOVER_RECT_ID,
    fill: HOVER_RECT_FILL,
    stroke: HOVER_RECT_FILL_VISIBLE,
    strokeWidth: HOVER_RECT_BORDER,
    opacity: 0
  });

  const dashedLine = new Konva.Line({
    points: [],
    stroke: '#fff',
    strokeWidth: 1,
    visible: false,
    dash: [5, 5]
  });

  const setHoverRectVisible = (visibility: boolean) => {
    hoverRect.opacity(Number(visibility));
    konvaLayer.batchDraw();
  };

  const setBackgroundVisible = (visible: boolean) => {
    dashedLine.visible(visible);
    visible ? hoverRect.fill(HOVER_RECT_FILL_VISIBLE) : hoverRect.fill(HOVER_RECT_FILL);
    konvaLayer.batchDraw();
  };

  const update = () => {
    const konvaGroup = konvaLayer.findOne(`#${currentSceneId}`);
    if (!konvaGroup) return;

    const scale = getScale(scalingMode, width, height, size.width, size.height);

    const rectWidth = Math.min(size.width * scale, width);
    const rectHeight = Math.min(size.height * scale, height) - HOVER_RECT_BORDER;

    const stripeWidth = (width - rectWidth) / 2;
    const stripeHeight = (height - rectHeight) / 2;

    const x = stripeWidth;
    const y = stripeHeight;
    hoverRect.setAttrs({ width: rectWidth, height: rectHeight, x, y });
    dashedLine.points([
      x + 10,
      y + 10,
      x + rectWidth - 10,
      y + 10,
      x + rectWidth - 10,
      y + rectHeight - 10,
      x + 10,
      y + rectHeight - 10,
      x + 10,
      y + 10
    ]);
    konvaLayer.batchDraw();
  };

  konvaLayer.add(hoverRect);
  konvaLayer.add(dashedLine);
  update();
  hoverRect.moveToBottom();

  return {
    update,
    setHoverRectVisible,
    setBackgroundVisible,
    hoverRect
  };
};
